import "../main.css";
import { useContext } from "react";
import { AppContext } from "../Theme";
import React from "react";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import Custom from "../components/custom/custom";
export default function Dashboard() {
	const { darkmode, toggleMode } = useContext(AppContext);

	// const [darkmode, setdarkMode] = useState(false);

	// const toggleMode = () => {
	// 	if (darkmode === false) {
	// 		setdarkMode(true);
	// 		document.body.style.backgroundColor = "#383854";
	// 	} else {
	// 		setdarkMode(false);
	// 		document.body.style.backgroundColor = "#F2F2FD";
	// 	}
	// };
	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar mode={darkmode} username="Nexcare" />
			</div>
			<Custom mode={darkmode} toggleMode={toggleMode} />
		</>
	);
}
